import { render, staticRenderFns } from "./ClinicDoctors.vue?vue&type=template&id=e63075f8"
import script from "./ClinicDoctors.vue?vue&type=script&lang=js"
export * from "./ClinicDoctors.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports